import Vue from 'vue';
import Chance from 'chance';

import walkNodes from './walkNodes';

function setDialoguePayload(payload, caseConf) {
  const { dialogue } = caseConf;
  
  // Questons
  payload.questions = [];
  walkNodes(payload, ['QUESTION', 'ANSWER'], (nodeData) => {
    const alreadyInPayload = payload.questions.find(q => q.id === nodeData.id);
    const question = dialogue.questions.find(q => q.id === nodeData.id);
    if (!alreadyInPayload && question) {
      payload.questions.push(question);
    }
  });

  // Commands
  payload.commands = [];
  walkNodes(payload, ['COMMAND', 'COMMAND_COUNT'], (nodeData) => {
    const alreadyInPayload = payload.commands.find(c => c.id === nodeData.id);
    const command = dialogue.commands.find(c => c.id === nodeData.id);
    if (!alreadyInPayload && command) {
      payload.commands.push(command);
    }
  });

  // Add unsolicited
  payload.unsolicited = [];
  walkNodes(payload, ['UNSOLICITED_DIALOGUE'], (nodeData) => {
    const alreadyInPayload = payload.unsolicited.find(c => c.id === nodeData.id);
    const unsolicited = dialogue.unsolicited.find(c => c.id === nodeData.id);
    if (!alreadyInPayload && unsolicited) {
      payload.unsolicited.push(unsolicited);
    }
  });

  // Add calls
  payload.calls = [];
  walkNodes(payload, ['CALL', 'CALL_ANSWER'], (nodeData) => {
    let alreadyInPayload = payload.calls.find(call => {
      const isCallIn = call.id === nodeData.callId;
      const isItemIn = isCallIn && call.items.find(item => item.id === nodeData.id);
      return isCallIn && isItemIn;
    });
    const call = dialogue.calls.find(c => c.id === nodeData.callId);
    const item = call.items.find(i => i.id === nodeData.id);
    if (!alreadyInPayload && call && item) {
      let payloadCall = payload.calls.find(c => c.id == call.id);
      if (!payloadCall) {
        payloadCall = {
          id: call.id,
          callee: call.callee,
          calleeVoiceId: call.calleeVoiceId,
          items: []
        };
        payload.calls.push(payloadCall);
      }
      payloadCall.items.push(item);
    }
  });
}

function pasteDialogue(caseConf, payload) {
  let areUpdates = false;

  // Copy questions
  if (payload.questions.length > 0) {
    if (!caseConf.dialogue.questions) {
      Vue.set(caseConf.dialogue, 'questions', []);
    }
    const questionMap = appendDialogue(caseConf.dialogue.questions, payload.questions);
    walkNodes(payload, ['QUESTION', 'ANSWER'], (nodeData) => {
      nodeData.id = questionMap[nodeData.id];
    });
    areUpdates = true;
  }

  // Copy commands
  if (payload.commands.length > 0) {
    if (!caseConf.dialogue.commands) {
      Vue.set(caseConf.dialogue, 'commands', []);
    }
    const commandMap = appendDialogue(caseConf.dialogue.commands, payload.commands);
    walkNodes(payload, ['COMMAND', 'COMMAND_COUNT'], (nodeData) => {
      nodeData.id = commandMap[nodeData.id];
    });
    areUpdates = true;
  }

  // Copy unsolicited
  if (payload.unsolicited.length > 0) {
    if (!caseConf.dialogue.unsolicited) {
      Vue.set(caseConf.dialogue, 'unsolicited', []);
    }
    const unsolicitedMap = appendDialogue(caseConf.dialogue.unsolicited, payload.unsolicited);
    walkNodes(payload, ['UNSOLICITED_DIALOGUE'], (nodeData) => {
      nodeData.id = unsolicitedMap[nodeData.id];
    });
    areUpdates = true;
  }

  // Copy calls
  if (payload.calls.length > 0) {
    if (!caseConf.dialogue.calls) {
      Vue.set(caseConf.dialogue, 'calls', []);
    }
    for (const payloadCall of payload.calls) {
      let caseCall = caseConf.dialogue.calls.find(call => call.callee.en === payloadCall.callee.en);
      if (!caseCall) {
        const chance = new Chance();
        caseCall = {
          id: chance.guid(),
          callee: {
            ...payloadCall.callee
          },
          calleeVoiceId: payloadCall.calleeVoiceId,
          items: []
        };
        caseConf.dialogue.calls.push(caseCall);
      }
      const callMap = appendDialogue(caseCall.items, payloadCall.items);
      walkNodes(payload, ['CALL', 'CALL_ANSWER'], (nodeData) => {
        if (callMap[nodeData.id]) {
          nodeData.id = callMap[nodeData.id];
          nodeData.callId = caseCall.id;
        }
      });
      areUpdates = true;
    }
  }

  return areUpdates;
}

function isContentEqual(content1, content2) {
  if (!content1 && !content2) {
    return true; // if field doesn't exist, treat it as true
  }
  // Compare two translated strings
  for (const [key, value] of Object.entries(content1)) {
    if (value !== content2[key]) {
      return false;
    }
  }
  return true;
}

function appendDialogue(destList, srcList) {
  const dialogueMap = {}; // { oldId: newId }
  const chance = new Chance();

  for (const item of srcList) {
    const existing = (destList || []).find(
      caseItem => {
        return isContentEqual(item.content, caseItem.content) &&
          isContentEqual(item.options.answer, caseItem.options.answer);
      }
    );
    if (existing) {
      dialogueMap[item.id] = existing.id;
    } else {
      const newQuestion = {
        id: chance.guid(),
        content: item.content,
        options: { 
          enabled: item.options.enabled, 
          answer: item.options.answer 
        },
      }
      destList.push(newQuestion);      
      dialogueMap[item.id] = newQuestion.id;
    }
  }

  // Update case position
  for (let i = 0; i < destList.length; i++) {
    destList[i].options.position = i;
  }
  
  return dialogueMap;
}

export {
  setDialoguePayload,
  pasteDialogue,
};
